import CtaCentered from './CtaCentered'
export default CtaCentered
